import { render } from "./MyProjetos.vue?vue&type=template&id=71dc3dfb&scoped=true&ts=true"
import script from "./MyProjetos.vue?vue&type=script&lang=ts"
export * from "./MyProjetos.vue?vue&type=script&lang=ts"

import "./MyProjetos.vue?vue&type=style&index=0&id=71dc3dfb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dc3dfb"]])

export default __exports__